import { Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import AgrRoom from "@/pages/AgrRoom";
import RequireAuth from "@/components/RequireAuth";
import LoginGuard from "@/pages/LoginGuard";
import Layout from "@/components/Layout";
import NotFound from "@/pages/NotFound";

export default function AppRoutes() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route
                    path="/agrRoom"
                    element={
                        <RequireAuth>
                            <AgrRoom />
                        </RequireAuth>
                    }
                />
                <Route path="/login" element={<LoginGuard />} />
                <Route path="/notfound" element={<NotFound />} />
            </Route>
            <Route path="*" element={<Navigate to="/notfound" replace />} />
        </Routes>
    );
}
